import React, { useEffect, useState } from 'react'
import { arrayOf, oneOfType, node, string } from 'prop-types'
import { cx } from '@emotion/css'

import styles from './styles'

const getNestedHeadings = headingElements => {
  const nestedHeadings = []

  headingElements.forEach(heading => {
    const { innerHTML: title, id, dataset } = heading
    if (dataset.level === '0') {
      nestedHeadings.push({
        id,
        title,
        level1: [],
        level2: [],
        level: dataset.level,
      })
    } else if (dataset.level === '1' && nestedHeadings.length > 0) {
      nestedHeadings[nestedHeadings.length - 1].level1.push({
        id,
        title,
        level: dataset.level,
      })
    } else if (dataset.level === '2' && nestedHeadings.length > 0) {
      nestedHeadings[nestedHeadings.length - 1].level2.push({
        id,
        title,
        level: dataset.level,
      })
    }
  })

  return nestedHeadings
}

/**
 * Dynamically generates the table of contents list, elements with `data-level` attribute
 */
const useHeadingsData = () => {
  const [nestedHeadings, setNestedHeadings] = useState([])

  useEffect(() => {
    const headingElements = document.querySelectorAll('[data-level]')

    const newNestedHeadings = getNestedHeadings(headingElements)
    setNestedHeadings(newNestedHeadings)
  }, [])

  return { nestedHeadings }
}

const ContentWithTOC = ({ children, className }) => {
  const { nestedHeadings } = useHeadingsData()

  return (
    <section className={cx(styles.container, className)}>
      <nav aria-label="Terms contents" className={styles.nav}>
        <ul>
          {nestedHeadings.map(heading => {
            return (
              <li key={heading.id}>
                <a href={`#${heading.id}`} className={styles.heading(heading.level)}>
                  {heading.title}
                </a>
                {heading.level1.length > 0 && (
                  <ul>
                    {heading.level1.map(child => (
                      <li key={child.id}>
                        <a href={`#${child.id}`} className={styles.heading(child.level)}>
                          {child.title}
                        </a>
                      </li>
                    ))}
                    {heading.level2.length > 0 && (
                      <ul>
                        {heading.level2.map(child => (
                          <li key={child.id}>
                            <a href={`#${child.id}`} className={styles.heading(child.level)}>
                              {child.title}
                            </a>
                          </li>
                        ))}
                      </ul>
                    )}
                  </ul>
                )}
              </li>
            )
          })}
        </ul>
      </nav>
      <article className={styles.content}>{children}</article>
    </section>
  )
}

ContentWithTOC.propTypes = {
  children: oneOfType([
    arrayOf(node),
    node,
  ]),
  className: string,
}

export default ContentWithTOC
